var map = {
	"./mvc/index.tsx": [
		645,
		7
	],
	"./svc/index.tsx": [
		646,
		8
	],
	"./tmvcs/index.tsx": [
		647,
		9
	],
	"./wvc/index.tsx": [
		648,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 571;
module.exports = webpackAsyncContext;